<!--横向滑动包裹类  -->
<template>
    <div class="Pointer" @click="onClick">
        <span class="text">{{text}}</span>
        <div class="arrowRight"></div>
    </div>
</template>


<script>

    export default {
        name: "Pointer",

        props: {
            text: {
                type: String,
                default: ""
            }

        },
        data() {
            return {};

        },
        methods: {
            onClick() {
                this.$emit("on-click");
            }


        }
    };
</script>
<style lang="less" scoped>
    @import "../../assets/less/common";

    .Pointer {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .text {
            color: @primary-color;
            font-size: .38rem;
            display: inline-block;
            margin-right: .05rem;
        }

        .arrowRight {

            width: 0;
            height: 0;
            border-top: .12rem solid transparent;
            border-bottom: .12rem solid transparent;
            border-left: .12rem solid #BCC6D0;
        }

    }

</style>
